<template>
  <form @submit.prevent="handleSubmit" @input="handleInput" autocomplete="off">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Es necesario actualizar tu contraseña</p>
      </header>
      <section class="modal-card-body">

        <div class="content">
          <p>Por politicas de seguridad es necesario crear una nueva contraseña para que puedas seguir accesando a la plataforma</p>
          <p><strong>Recuerda que las contraseñas deben contener números y letras, la una longitud debe ser de {{$auth.user().min_password_length}} caracteres</strong></p>
          <p>Tu nueva contraseña debe incluir alguno de estos caracteres permitidos: <span style="color: orange">!#$%&/()=?¡¿?.[]{}*-_;</span></p>
        </div>

        <b-field label="Password" :type="errors.password ? 'is-danger' : null" :message="errors.password ? errors.password : null">
          <b-input
              type="password"
              :value="password"
              password-reveal
              placeholder="Contraseña"
              :maxlength="$auth.user().max_password_length"
              v-model="password"
              name="password"
              :minlength="$auth.user().min_password_length"
              required>
          </b-input>
        </b-field>

        <b-field label="Confirmar contraseña" :type="errors['password-confirm'] ? 'is-danger' : null" :message="errors['password-confirm'] ? errors['password-confirm'] : null">
          <b-input
              type="password"
              password-reveal
              :maxlength="$auth.user().max_password_length"
              v-model="passwordConfirm"
              name="password-confirm"
              :minlength="$auth.user().min_password_length"
              placeholder="Confirmar contraseña"
              required>
          </b-input>
        </b-field>

      </section>
      <footer class="modal-card-foot">
        <b-button
            :disabled="hasErrors"
            native-type="submit"
            label="Actualizar contraseña"
            type="is-primary" />
        <b-button
          native-type="button"
          @click="$auth.logout().then(() => {$emit('close')})"
          label="Cerrar sesión"
          type="is-danger is-light" />
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: "UpdatePasswordModal",
  data() {
    return {
      password: '',
      passwordConfirm: '',
      errors: {}
    }
  },
  computed: {
    hasErrors() {
      return (Object.keys(this.errors).length > 0 && this.errors.password !== '' && this.errors['password-confirm'] !== '') || (this.password === '' || this.password !== this.passwordConfirm);
    }
  },
  methods: {
    handleSubmit() {
      if(this.password === this.passwordConfirm && this.password.length >= this.$auth.user().min_password_length){
        this.$loader.show();
        this.$http.put('user/password', {password: this.password, password_confirmation: this.passwordConfirm}).then(() => {
          this.$toast.success('Contraseña actualizada correctamente');
          this.$emit('close');
        }).catch(errors => {
          const messageErrors = errors.response.data.errors ? Object.values(errors.response.data.errors).flat().join('<br>') : '';
          this.$buefy.dialog.alert({
            title: errors.response.data.message,
            message: messageErrors
          })
        }).finally(() => {
          this.$loader.hide();
        })
      }
    },
    handleInput(event) {
      //console.log(event.target, event.target.validity.valid, event.target.validationMessage);
      if(!this.errors[event.target.name]){
        this.errors[event.target.name] = '';
      }
      if(!event.target.validity.valid){
        this.errors[event.target.name] = event.target.validationMessage;
      }else if(event.target.name === 'password-confirm' && this.password !== this.passwordConfirm){
        this.errors['password-confirm'] = 'Las contraseñas no coinciden';
      }else{
        this.errors[event.target.name] = '';
      }
      this.errors = {...this.errors};
    }
  }
}
</script>

<style scoped>

</style>